import React from 'react'
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout'
import styles from "./footer.module.css"
import { Phone } from '../../ui/phone/Phone'
import { Telegram } from '../../ui/telegram/Telegram'
import { Button } from '../../ui/button/Button'
import { Link, NavLink } from "react-router";
import { VK } from '../../ui/vk/VK'
import { Dzen } from '../../ui/dzen/dzen'
export function Footer() {
    return (
        <footer className={styles.footer}>
            <MarkupLayout>
                <div className={styles.footer__holder}>
                    <div className={styles.contacts__container}>
                        <Link to={"/"}>
                            <img className={styles.footer__logo} src="/images/logo.webp" alt="logo" />
                        </Link>
                        <div className={styles.footer__contacts_text_container}>
                            <div>ООО «Легенд Групп»</div>
                            <div><a href="tel:+74992882648">+7 499 288-26-48</a></div>
                            <div><a href="mailto:info@sct-germany.ru">info@sct-germany.ru</a> </div>
                        </div>
                        <div className={styles.footer__contacts_icons}>
                            <Phone color={"white-sct"} />

                            <Telegram color={"white-sct"} />
                            <VK color={"white-sct"} />
                            <Dzen color={"white-sct"} />
                        </div>
                        <div className={styles.footer__nav_holder_mobile}>
                            <div><NavLink to="/catalog">Каталог</NavLink></div>
                            <div><NavLink to="/faq">FAQ</NavLink></div>
                            <div><NavLink to="/">Обратная связь</NavLink></div>
                            <div><NavLink to="/about-us">О нас</NavLink></div>
                            <div><NavLink to="/contacts">Контакты</NavLink></div>
                        </div>

                    </div>
                    <div className={styles.wrapper}>
                        <div className={styles.footer__list_container}>
                            <div >
                                <NavLink to='/car-filters' className={styles.footer__bold_text}>Автомобильные фильтры</NavLink>
                                <ul className={styles.footer__list}>
                                    <li className={styles.footer__list_item}><NavLink to="/car-filters/airfilter">Масляные фильтр</NavLink></li>
                                    <li className={styles.footer__list_item}><NavLink to="/car-filters/oilfilter">Воздушные фильтры</NavLink></li>
                                    <li className={styles.footer__list_item}><NavLink to="/car-filters/fuelfilter">Топливные фильтр</NavLink></li>
                                    <li className={styles.footer__list_item}><NavLink to="/car-filters/cabinfilter">Салонные фильтры</NavLink></li>
                                    <li className={styles.footer__list_item}><NavLink to="/car-filters/transmissionfilter">АКПП фильтры</NavLink></li>
                                </ul>
                            </div>
                            <div>
                                <NavLink to='/brake-pads' className={styles.footer__bold_text}>Тормозные колодки</NavLink>
                                <ul className={styles.footer__list}>
                                    <li className={styles.footer__list_item}><NavLink to="/brake-pads/discpads">Дисковые колодки</NavLink></li>
                                    <li className={styles.footer__list_item}><NavLink to="/brake-pads/drumpads">Барабанные колодки</NavLink></li>

                                </ul>
                            </div>
                            <div>
                                <NavLink to='/wiper-blades' className={styles.footer__bold_text}>Щетки стеклоочистителя</NavLink>
                                <ul className={styles.footer__list}>
                                    <li className={styles.footer__list_item}><NavLink to="/wiper-blades/carcass">Каркасные шетки</NavLink></li>
                                    <li className={styles.footer__list_item}><NavLink to="/wiper-blades/withoutcarcass">Бескаркасные шетки</NavLink></li>
                                    <li className={styles.footer__list_item}><NavLink to="/wiper-blades/hybrid">Гибридные шетки</NavLink></li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.footer__nav_holder}>
                            <div><NavLink to="/catalog">Каталог</NavLink></div>
                            <div><NavLink to="/faq">FAQ</NavLink></div>
                            <div><NavLink to="/feedback">Обратная связь</NavLink></div>
                            <div><NavLink to="/about-us">О нас</NavLink></div>
                            <div><NavLink to="/contacts">Контакты</NavLink></div>
                            <Button variant={"white"} width={"w-310"} behaviour='link' link="/catalog">Каталог подбора</Button>
                        </div>

                    </div>
                </div>
                <div className={styles.footer__rights}>
                    <Button variant={"white"} width={"w-310"} behaviour='link' link="/catalog">Каталог подбора</Button>

                    <div className={styles.footer__rights_container} >
                        <p>«SCT GERMANY» {new Date().getFullYear()}</p>
                        <p>©️ Все права защищены!</p>
                        <Link to="/policy">Политика конфиденциальности</Link>
                        {/* <Link to="/cookie-policy">Политика файлов Cookie</Link> */}
                    </div>
                </div>

            </MarkupLayout>
        </footer>
    )
}
